// Manager Lab / Players / Pool / Focus API client (Phase 1)
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const searchPlayers = (q, limit = 8) =>
    axios.get(`${API}/players/search`, { params: { q, limit } }).then((r) => r.data);
export const resolvePlayer = (key) =>
    axios.get(`${API}/players/resolve/${encodeURIComponent(key)}`).then((r) => r.data);
export const playerProfile = (key) =>
    axios.get(`${API}/players/${encodeURIComponent(key)}/profile`).then((r) => r.data);

export const getPool = () => axios.get(`${API}/pool`).then((r) => r.data);
export const addToPool = (payload) => axios.post(`${API}/pool`, payload).then((r) => r.data);
export const patchPoolEntry = (id, payload) => axios.patch(`${API}/pool/${id}`, payload).then((r) => r.data);
export const removePoolEntry = (id) => axios.delete(`${API}/pool/${id}`).then((r) => r.data);
export const removePoolByFpl = (fplId) => axios.delete(`${API}/pool/by-fpl/${fplId}`).then((r) => r.data);
export const poolTimingEntries = () => axios.get(`${API}/pool/timing-entries`).then((r) => r.data);
export const radarSmSearch = (q) => axios.get(`${API}/radar/sm-search`, { params: { q } }).then((r) => r.data);
export const radarSmPlayer = (id, seasonId) => axios.get(`${API}/radar/sm-player/${id}`, { params: seasonId ? { season_id: seasonId } : {} }).then((r) => r.data);
export const radarParseProfile = (text) => axios.post(`${API}/radar/parse-profile`, { text }, { timeout: 60000 }).then((r) => r.data);
export const importPool = (players) => axios.post(`${API}/pool/import`, { players }).then((r) => r.data);

export const listFocuses = (status) =>
    axios.get(`${API}/focuses`, { params: status ? { status } : {} }).then((r) => r.data);
export const createFocus = (payload) => axios.post(`${API}/focuses`, payload).then((r) => r.data);
export const patchFocus = (id, payload) => axios.patch(`${API}/focuses/${id}`, payload).then((r) => r.data);
export const archiveFocus = (id) => axios.delete(`${API}/focuses/${id}`).then((r) => r.data);
export const recruitFocus = (id) => axios.post(`${API}/focuses/${id}/recruit`).then((r) => r.data);
export const getFocus = (id) => axios.get(`${API}/focuses/${id}`).then((r) => r.data);
export const listCandidates = (fid) => axios.get(`${API}/focuses/${fid}/candidates`).then((r) => r.data);
export const addCandidate = (fid, payload) => axios.post(`${API}/focuses/${fid}/candidates`, payload).then((r) => r.data);
export const patchCandidate = (fid, cid, payload) => axios.patch(`${API}/focuses/${fid}/candidates/${cid}`, payload).then((r) => r.data);
export const removeCandidate = (fid, cid) => axios.delete(`${API}/focuses/${fid}/candidates/${cid}`).then((r) => r.data);
export const CANDIDATE_STATUS_LABELS = {
    DISCOVERED: "Objeven", SCOUTING: "Ve scoutingu", MONITORED: "Sledován", REJECTED: "Vyřazen",
    FINALIST: "Finalista", SELECTED: "Vybrán", ALTERNATIVE: "Alternativa",
};
export const getScoutReport = (fid, cid) => axios.get(`${API}/focuses/${fid}/candidates/${cid}/report`).then((r) => r.data);
export const putScoutReport = (fid, cid, payload) => axios.put(`${API}/focuses/${fid}/candidates/${cid}/report`, payload).then((r) => r.data);
export const aiScoutReport = (fid, cid) => axios.post(`${API}/focuses/${fid}/candidates/${cid}/report/ai`, {}, { timeout: 90000 }).then((r) => r.data);
export const orderFinalists = (fid, order) => axios.post(`${API}/focuses/${fid}/finalists/order`, { order }).then((r) => r.data);
export const saveDecision = (fid, payload) => axios.post(`${API}/focuses/${fid}/decision`, payload).then((r) => r.data);
export const cancelDecision = (fid) => axios.delete(`${API}/focuses/${fid}/decision`).then((r) => r.data);
export const getLists = () => axios.get(`${API}/lists`).then((r) => r.data);
export const createList = (payload) => axios.post(`${API}/lists`, payload).then((r) => r.data);
export const deleteList = (lid) => axios.delete(`${API}/lists/${lid}`).then((r) => r.data);
export const addListPlayer = (lid, fpl_id) => axios.post(`${API}/lists/${lid}/players`, { fpl_id }).then((r) => r.data);
export const removeListPlayer = (lid, fpl_id) => axios.delete(`${API}/lists/${lid}/players/${fpl_id}`).then((r) => r.data);
export const trackerOverview = (params = {}) => axios.get(`${API}/tracker/overview`, { params, timeout: 60000 }).then((r) => r.data);
export const monitorRefresh = (fid) => axios.post(`${API}/focuses/${fid}/monitor/refresh`, {}, { timeout: 60000 }).then((r) => r.data);
export const focusRecommendations = (id) => axios.get(`${API}/focuses/${id}/recommendations`).then((r) => r.data);
export const saveRecruiterList = (id, label) => axios.post(`${API}/focuses/${id}/recommendations/save`, { label: label || null }).then((r) => r.data);
export const listRecruiterLists = () => axios.get(`${API}/recruiter/lists`).then((r) => r.data);
export const recruiterListDetail = (id) => axios.get(`${API}/recruiter/lists/${id}`).then((r) => r.data);
export const deleteRecruiterList = (id) => axios.delete(`${API}/recruiter/lists/${id}`).then((r) => r.data);

export const labSummary = () => axios.get(`${API}/lab/summary`).then((r) => r.data);

export const selectCompare = (fpl_ids, focus_id) =>
    axios.post(`${API}/select/compare`, { fpl_ids, focus_id: focus_id || null }).then((r) => r.data);
export const focusSelect = (id, payload) =>
    axios.post(`${API}/focuses/${id}/select`, payload).then((r) => r.data);
export const listScenarios = () => axios.get(`${API}/scenarios`).then((r) => r.data);
export const createScenario = (payload) => axios.post(`${API}/scenarios`, payload).then((r) => r.data);
export const patchScenario = (id, payload) => axios.patch(`${API}/scenarios/${id}`, payload).then((r) => r.data);
export const deleteScenario = (id) => axios.delete(`${API}/scenarios/${id}`).then((r) => r.data);
export const reviewPool = (horizon) => axios.get(`${API}/review/pool`, { params: { horizon } }).then((r) => r.data);
export const reviewFocuses = () => axios.get(`${API}/review/focuses`).then((r) => r.data);
export const reviewBksa = () => axios.get(`${API}/review/bksa`).then((r) => r.data);
export const funDuel = (params) => axios.get(`${API}/fun/duel`, { params }).then((r) => r.data);
export const funResult = (game, correct) => axios.post(`${API}/fun/result`, { game, correct }).then((r) => r.data);
export const funPriceRound = (params) => axios.get(`${API}/fun/price-guess/round`, { params }).then((r) => r.data);
export const findPlayers = (params) => axios.get(`${API}/players/find`, { params }).then((r) => r.data);
export const scoutFocuses = () => axios.get(`${API}/scout/focuses`).then((r) => r.data);
export const scoutFocusDetail = (id) => axios.get(`${API}/scout/focuses/${id}`).then((r) => r.data);
export const scoutSubmit = (id, payload) => axios.post(`${API}/scout/focuses/${id}/submit`, payload).then((r) => r.data);
export const scoutRetract = (id, fplId) => axios.delete(`${API}/scout/focuses/${id}/submit/${fplId}`).then((r) => r.data);
export const scoutLeaderboard = () => axios.get(`${API}/scout/leaderboard`).then((r) => r.data);

export const FIT_LABELS = {
    budget_fit: "Budget", fixture_fit: "Fixtures", minutes_security: "Minuty",
    points: "Body", value: "Value", ownership_diff: "Diff",
};
export const DECISION_TYPES = [
    { key: "buy_now", label: "Buy Now" },
    { key: "wait_one_gw", label: "Wait One GW" },
    { key: "monitor_team_news", label: "Monitor Team News" },
    { key: "use_as_alternative", label: "Use as Alternative" },
    { key: "reject", label: "Reject" },
    { key: "return_to_watch", label: "Return to Watch" },
];

export const POOL_STATUSES = [
    { key: "watch", label: "Watch", color: "text-white/60 border-white/20" },
    { key: "scouted", label: "Scouted", color: "text-fa-sky border-fa-sky/40" },
    { key: "shortlist", label: "Shortlist", color: "text-fa-yellow border-fa-yellow/40" },
    { key: "priority", label: "Priority", color: "text-fa-mint border-fa-mint/50" },
];

export const FOCUS_TYPES = [
    { key: "replacement", label: "Náhrada konkrétního hráče" },
    { key: "long_term_starter", label: "Dlouhodobý starter" },
    { key: "short_term_punt", label: "Krátkodobý punt" },
    { key: "differential", label: "Differential" },
    { key: "cheap_bench", label: "Levná lavička" },
    { key: "captaincy", label: "Kapitánská možnost" },
    { key: "fixture_swing", label: "Hráč na fixture swing" },
    { key: "rotation", label: "Hráč pro rotaci" },
    { key: "wildcard", label: "Wildcard kandidát" },
    { key: "free_form", label: "Volné zadání" },
];

export const FOCUS_STATUS_LABELS = {
    draft: "Draft", active: "Active", selection_made: "Selection Made",
    playing: "Playing", ready_for_review: "Ready for Review",
    completed: "Completed", archived: "Archived",
};
